import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Header = ({ onOpenAIVoiceModal }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDesignDropdownOpen, setIsDesignDropdownOpen] = useState(false);
  const [isMobileDesignOpen, setIsMobileDesignOpen] = useState(false);
  const designDropdownRef = useRef(null);

  const primaryLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/experience", label: "Experience" },
    { path: "/projects", label: "Projects" },
    { path: "/academic", label: "Academic" },
    { path: "/research", label: "Research" },
  ];

  useEffect(() => {
    if (!isDesignDropdownOpen) return;
    const handleClickOutside = (event) => {
      if (
        designDropdownRef.current &&
        !designDropdownRef.current.contains(event.target)
      ) {
        setIsDesignDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDesignDropdownOpen]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-lr from-slate-900/95 to-purple-900/95 backdrop-blur-sm border-b border-gray-700/50 shadow-2xl">
      <nav className="container mx-auto px-4 md:px-6 py-3 md:py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link
            to="/"
            className="text-lg md:text-2xl font-bold bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent hover:from-cyan-300 hover:to-purple-300 transition-all duration-300 truncate max-w-[180px] md:max-w-none"
          >
    
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex xl:space-x-8 lg:space-x-4 items-center text-sm xl:text-base">
            {primaryLinks.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-gray-300 hover:text-cyan-400 transition-colors duration-300 font-medium"
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link
              to="/contact"
              className="px-4 py-2 lg:px-6 bg-gradient-to-r from-cyan-500 to-purple-500 text-white font-semibold rounded-full hover:from-cyan-400 hover:to-purple-400 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 transform hover:scale-105 whitespace-nowrap text-sm lg:text-base"
            >
              Let's Connect
            </Link>
            <button
              type="button"
              onClick={onOpenAIVoiceModal}
              className="px-4 py-2 lg:px-6 bg-gradient-to-r ml-3 from-cyan-500 to-purple-500 text-white font-semibold rounded-full hover:from-cyan-400 hover:to-purple-400 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 transform hover:scale-105 whitespace-nowrap text-sm lg:text-base"
            >
              AI Assistant
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden text-gray-300 hover:text-cyan-400 transition-colors duration-300"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
     
      </nav>
    </header>
  );
};

export default Header;
